<template>
    <div class="w1200">

        <div class="top-bar" style="display:flex;align-items:center;justify-content:space-between;">

            <div class="lottery">
                <span v-for="(item, index) in lotteryArr" :key="index" :class="{ active: queryParams.preType == index }"
                    @click="queryList('lottery', index)">{{ item }}</span>
            </div>
            <div style="color:#bd3147;font-weight:bold;">
                <span style="margin-left:30px;cursor: pointer;" @click="$refs.xianzhiDingzhi.init()">闲置/定制表格订单汇总表</span>
                <!--                <span style="margin-left:30px;cursor: pointer;" @click="$refs.feichun.feichunShow = true;">非纯EXCEL缩水技巧授之以渔本</span>-->
            </div>
        </div>

        <div class="type">
            <div>
                <span v-for="(item, index) in type.arr" :key="index">{{
                    item
                    }}</span>
            </div>
            <div class="type-extra" style="display:flex;align-items:center;">
                <div class="warm-tip" style="
                    margin-right:20px;
                    border:1px solid rgba(0,0,0,.2);
                    color:rgba(0,0,0,.5);
                    display:inline-block;
                    padding:10px;
                    border-radius:10px;
                    ">
                    温馨提示:没有永远正确的规律性条件，规律始终在周期性运动
                </div>
                <span class="apply_sss">申请技巧师</span>
            </div>
        </div>
        <div class="table">
            <!-- <div class="head">
                <div>双色球123123期技巧师EXCEL图表汇总</div>
                <div>
                    <span>最新期</span>
                    <span>上一期</span>
                    <span>下一期</span>
                </div>
                <div>
                    <span>EXCEL表VIP学霸区</span>
                </div>
                <div>双色球开奖结果：每周二，四，日 21：30</div>
            </div> -->
            <div class="head">
                <div class="tit">{{ handleLottery }}{{ queryParams.number }}期技巧师EXCEL图表汇总</div>
                <div class="nav">
                    <span v-for="(item, index) in numberStatusArr" :key="index"
                        @click="queryList('numberStatus', index)" :class="{ active: queryParams.type == index }">{{ item
                        }}</span>
                </div>
                <div class="nav">
                    <span v-for="(item, index) in typeVIPArr" :key="index" @click="queryList('typeVIP', index)"
                        :class="{ active: queryParams.hasFree == index }">{{ item }}</span>
                </div>
                <div>双色球开奖结果：每周二，四，日 21：30</div>
            </div>

            <template v-if="['0', '1', 0, 1].includes(queryParams.preType)">
                <!-- 双色球,大乐透 -->
                <el-table :data="tableData" v-loading="tabledataLoading" border style="width: 100%" align="center"
                    :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
                    <el-table-column type="index" width="50" label="序号" />
                    <el-table-column prop="number" min-width="90" label="期号" />
                    <el-table-column prop="nickName" min-width="110" label="技巧师">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="view_history(scope.row)">{{ scope.row.nickName
                                }}</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="gzl" :show-overflow-tooltip="true" label="关注量" /> -->
                    <el-table-column prop="excelNum" :show-overflow-tooltip="true" label="excel红蓝表" width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleDownload(scope.row)" type="text" size="small">{{ scope.row.excelNum
                                }}张 {{ scope.row.allCoin }}缩币下载</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="redTotal" :show-overflow-tooltip="true" label="上期图表汇总准确率" width="150" />
                    <el-table-column prop="total" :show-overflow-tooltip="true" label="上期红球表准确率" width="150" />
                    <el-table-column prop="blueTotal" :show-overflow-tooltip="true" label="上期蓝球表准确率" width="150" />
                    <!-- <el-table-column prop="browseNumber" :show-overflow-tooltip="true" label="浏览量" /> -->
                    <el-table-column prop="createTime" :show-overflow-tooltip="true" label="发布时间" width="210" />
                </el-table>
            </template>

            <template v-if="['2', '3', 2, 3].includes(queryParams.preType)">
                <!-- 福彩3D,排列三 -->
                <el-table :data="tableData" v-loading="tabledataLoading" border style="width: 100%" align="center"
                    :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
                    <el-table-column type="index" width="50" label="序号" />
                    <el-table-column prop="number" min-width="90" label="期号" />
                    <el-table-column prop="nickName" min-width="110" label="技巧师">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="view_history(scope.row)">{{ scope.row.nickName
                            }}</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="gzl" :show-overflow-tooltip="true" label="关注量" /> -->
                    <el-table-column prop="excel" min-width="150" :show-overflow-tooltip="true" label="excel福彩表">
                        <template slot-scope="scope">
                            <el-button @click="handleDownload(scope.row)" type="text" size="small">{{ scope.row.excelNum
                                }}张 {{ scope.row.allCoin }}缩币下载</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="redTotal" min-width="150" :show-overflow-tooltip="true" label="上期图表汇总准确率" />
                    <!-- <el-table-column prop="ll" :show-overflow-tooltip="true" label="浏览量" /> -->
                    <el-table-column prop="createTime" min-width="150" :show-overflow-tooltip="true" label="发布时间" />
                </el-table>
            </template>

            <div class="pagination" v-if="paginParams.total">
                <hxlPagin :queryParams="paginParams" @changePage="changePage" />
            </div>

        </div>

        <pay ref="pay" />

        <xianzhiDingzhi ref='xianzhiDingzhi' />
        <feichun ref='feichun' />

    </div>
</template>

<script>
import pay from "@/components/pay.vue";

import xianzhiDingzhi from "./huizong/xianzhi_dingzhi.vue";
import feichun from "./huizong/feichun.vue";

import { createOrder } from "@/api/common"

import hxlPagin from "@/components/hxlPagin";

import payDownloadFile from "@/utils/payDownloadFile";

export default {
    mixins: [payDownloadFile],
    components: {
        pay,
        feichun,
        xianzhiDingzhi,
        hxlPagin,
    },
    computed: {
        handleLottery() {
            let lottery = this.queryParams.preType;
            let lotteryArr = ["双色球", "大乐透", "福彩3D", "体彩排三"];
            return lotteryArr[lottery]
        }
    },
    data() {
        return {
            lotteryArr: ["双色球", "大乐透", "福彩3D", "体彩排三"],
            numberStatusArr: ["最新期", "上一期", "下一期"],
            typeVIPArr: ["免费", "VIP学霸区"],

            type: {
                arr: ["excel学霸", "最新excel", "人气榜"],
                active: 0,
            },
            tableData: [],
            tabledataLoading: false,
            latestNumber: '',
            listRequestId: 0,

            paginParams: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },

            queryParams: {
                preType: '0', // 预测类型 0双色球 1大乐透 2 3D 3排三
                number: '', // 期数，始终存字符串，加减前先转数字
                type: '0',  // (0: 最新期 1：上一期  2：下一期)
                hasFree: '0',	// (0：免费 1：VIP学霸区)
                // score: '',	// 积分榜
                // favorites: '', // 人气榜
                createUser: '', // 发布者id
            },

        };
    },
    created() {
        this.init();
    },
    mounted() {
        this.fetchCaizhongData()
    },
    methods: {
        resetPageNum() {
            this.paginParams.pageNum = 1
        },

        fetchCaizhongData() {
            const caizhong = this.$route.query.caizhong;

            if (caizhong === 'xianzhi') {
                this.queryParams.preType = 0
                this.$nextTick(() => {
                    if (this.$refs.xianzhiDingzhi) {
                        this.$refs.xianzhiDingzhi.init()
                    }
                })
                return
            }

            const maping = ['sss', 'dlt', '3d', 'pl3']
            const idx = maping.indexOf(caizhong)
            if (idx === -1) {
                return
            }
            this.queryParams.preType = idx
            this.queryParams.hasFree = '0'
            this.queryParams.type = '0'
            this.resetPageNum()
            this.getCurrentNumber()
        },

        init() {
            if (this.vuex_userInfo && this.vuex_userInfo.userId) {
                this.queryParams.createUser = this.vuex_userInfo.userId;
            } else {
                console.warn('用户信息未加载')
            }
            this.resetPageNum()
            this.getCurrentNumber();
        },

        getCurrentNumber() {
            this.$http.get('/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + this.queryParams.preType).then(res => {
                if (res.data && res.data.next) {
                    this.latestNumber = String(res.data.next)
                    this.queryParams.number = this.latestNumber
                    this.getList();
                } else {
                    console.error('获取期号失败：返回数据为空')
                }
            }).catch(err => {
                console.error('获取期号失败：', err)
            })
        },

        shiftPeriod(delta) {
            const raw = this.queryParams.number
            if (raw === '' || raw == null) {
                this.$message.warning('期号无效')
                return false
            }
            const current = Number(raw)
            if (!Number.isFinite(current)) {
                this.$message.warning('期号无效')
                return false
            }
            if (delta < 0) {
                const prev = current - 1
                if (prev <= 0) {
                    this.$message.warning('没有上一期了')
                    return false
                }
                this.queryParams.number = String(prev)
                return true
            }
            const latest = Number(this.latestNumber)
            if (!Number.isFinite(latest) || current >= latest) {
                this.$message.warning('已经是最新期')
                return false
            }
            this.queryParams.number = String(current + 1)
            return true
        },

        queryList(type, index) {
            if (type == 'lottery') {
                this.queryParams.preType = index
                this.queryParams.hasFree = '0'
                this.queryParams.type = '0'
                this.resetPageNum()
                this.getCurrentNumber();
                return
            }
            if (type == 'numberStatus') {
                if (index == 0) {
                    this.queryParams.type = '0'
                    this.resetPageNum()
                    this.getCurrentNumber()
                    return
                }
                if (!this.shiftPeriod(index == 1 ? -1 : 1)) {
                    return
                }
                this.queryParams.type = String(index)
                this.resetPageNum()
            }

            if (type == 'typeVIP') {
                this.queryParams.hasFree = String(index)
                this.resetPageNum()
            }

            this.getList();

        },

        getList() {
            const requestId = ++this.listRequestId
            this.tabledataLoading = true;
            const paginParams = this.$utils.getParamByJson({
                pageNum: this.paginParams.pageNum,
                pageSize: this.paginParams.pageSize
            });
            this.$http.post('/stage-api/teach/list?' + paginParams, this.queryParams).then(res => {
                if (requestId !== this.listRequestId) {
                    return
                }
                this.paginParams.total = res.total || 0
                this.tableData = Array.isArray(res.rows) ? res.rows : []
            }).finally(() => {
                if (requestId === this.listRequestId) {
                    this.tabledataLoading = false;
                }
            });
        },

        changePage(e) { this.paginParams.pageNum = e; this.getList(); },

        view_history(row) {
            let mappingLottery = ['ssq', 'dlt', 'fcsd', 'pls'];
            this.$router.push({
                path: '/dating_viewHistory',
                query: {
                    shrinkId: row.createUser,
                    number: row.number,
                    userName: row.nickName,
                    preType: mappingLottery[this.queryParams.preType],
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.lottery {
    margin: 10px 0;

    span {
        display: inline-block;
        padding: 20px 30px;
        background-color: #dbdbdb;
        cursor: pointer;

        &.active {
            background-color: #93d2f3;
            color: #000;
        }
    }
}

.type {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;

    >div {
        span {
            display: inline-block;
            padding: 20px 30px;
        }
    }

    .apply_sss {
        padding: 10px 20px;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        cursor: pointer;
    }
}

.table {
    .head {
        margin: 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tit {
            color: #347caf;
            font-weight: bold;
            font-size: 20px;
        }

        .nav {
            span {
                background-color: #dbdbdb;
                border: 1px solid rgba(0, 0, 0, 0.2);
                padding: 5px 10px;
                margin-right: 10px;
                border-radius: 10px;
                cursor: pointer;

                &.active {
                    background-color: #93d2f3;
                }
            }
        }

        span {
            display: inline-block;
            padding: 0 10px;
        }
    }

    .pagination {
        margin: 30px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 顶部：彩种平分一行，右侧「闲置/定制表格订单汇总表」换到下一行 */
    .top-bar {
        flex-wrap: wrap;
        row-gap: 10px;

        .lottery {
            display: flex;
            width: 100%;

            span {
                flex: 1;
                text-align: center;
                padding: 12px 4px;
                font-size: 15px;
            }
        }

        >div {
            width: 100%;
            font-size: 13px;

            span {
                margin-left: 0 !important;
            }
        }
    }

    /* 筛选区：纵向堆叠；温馨提示与按钮同一行，按钮不压缩 */
    .type {
        flex-direction: column;
        align-items: stretch;
        row-gap: 10px;

        >div {
            span {
                padding: 10px 12px;
                font-size: 14px;
            }
        }

        .type-extra {
            display: flex;
            align-items: center;

            .warm-tip {
                flex: 1;
                min-width: 0;
                margin-right: 10px !important;
                font-size: 12px;
                line-height: 1.6;
            }

            .apply_sss {
                flex: none;
                padding: 8px 14px;
                font-size: 13px;
                white-space: nowrap;
            }
        }
    }

    /* 表头：标题、筛选标签、开奖说明改为纵向排列 */
    .table {
        .head {
            flex-direction: column;
            align-items: flex-start;
            row-gap: 10px;

            .tit {
                font-size: 16px;
                line-height: 1.6;
            }

            .nav span {
                padding: 6px 12px;
                margin-right: 8px;
                font-size: 13px;
            }

            >div {
                font-size: 13px;
                color: #555;
            }
        }
    }

    /* 分页：窄屏居中显示，避免右对齐被截断 */
    ::v-deep .pagin .el-pagination {
        padding-top: 16px !important;
        text-align: center !important;
    }
}
</style>
